export default __webpack_public_path__ + "static/media/donation-banner.9784785c.png";